import { render } from "./ManageHistoryPage.vue?vue&type=template&id=48d6cfb6"
import script from "./ManageHistoryPage.vue?vue&type=script&lang=ts"
export * from "./ManageHistoryPage.vue?vue&type=script&lang=ts"

import "./ManageHistoryPage.vue?vue&type=style&index=0&id=48d6cfb6&lang=scss"
script.render = render

export default script